import * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';
import type { ConfirmDialogResult } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	readonly onDiscard: () => void;
	readonly onContinue: () => void;
};

/** Discarding an unsaved name is reversible (the title is untouched), so a plain `ConfirmDialog` is enough. */
const DiscardRenameDialog: React.FC<Props> = ({ visible, onDiscard, onContinue }) => {
	// Every exit except the accept button (reject, cross, Escape, mask) keeps the editor open.
	const handleHide = React.useCallback(
		(result: ConfirmDialogResult) => {
			if (result !== 'accept') {
				onContinue();
			}
		},
		[onContinue],
	);

	return (
		<ConfirmDialog
			blockScroll
			closable
			draggable={false}
			visible={visible}
			onHide={handleHide}
			header="Abandonner les modifications ?"
			message="Le nouveau nom n'a pas été enregistré. Si vous abandonnez, le nom actuel est conservé."
			acceptLabel="Abandonner"
			rejectLabel="Continuer l'édition"
			defaultFocus="reject"
			accept={onDiscard}
		/>
	);
};

export default DiscardRenameDialog;
